export const REGISTER_FORM_STRINGS = {
  title: 'Set Password',
  description:
    "You've been invited to join the platform. Please set your password to complete the registration.",
  passwordLabel: 'Password',
  passwordRequired: 'Password is required',
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordRequired: 'Please confirm your password',
  passwordsDoNotMatch: 'Passwords do not match',
  setPasswordButton: 'Set Password',
  settingPasswordButton: 'Setting Password...',
} as const
